import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { InternalPresettingBuilder } from '../../models/builders/internal-presetting.builder';
import { InternalPresetting } from '../../models/internal-presetting';

const saveInternalPresettingBody = (internalPresetting: InternalPresetting) => ({
   name: internalPresetting.name,
   active: internalPresetting.active
});

@Injectable()
export class InternalPresettingApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}internal-presettings`;
  }

  getInternalPresettings() {
    return this.httpClient.get(`${this.apiUrl}`).pipe(map(InternalPresettingBuilder.fromList));
  }

  getInternalPresetting(hash: string) {
    return this.httpClient.get(`${this.apiUrl}/${hash}`)
      .pipe(
        map(InternalPresettingBuilder.fromJson)
      );
  }

  getErpInternalPresetting() {
    return this.httpClient.get(`${this.apiUrl}/erp`)
      .pipe(
        map(InternalPresettingBuilder.fromJson)
      );
  }

  updateInternalPresetting(internalPresetting: InternalPresetting) {
    return this.httpClient.put(`${this.apiUrl}/${internalPresetting.hash}`, saveInternalPresettingBody(internalPresetting));
  }

  getActiveErpInternalPresetting() {
    return this.httpClient.get(`${this.apiUrl}/active-erp`)
      .pipe(
        map(InternalPresettingBuilder.fromList)
      );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/internal-presetting-api.service.ts